<template>
    <div class="header-wrap">
        <div class="font-3 title" v-once>
            {{ schema.name }}
        </div>
        <div class="grid grid-titles" v-once>
            <span class="font-7">
                Applications
            </span>
            <span class="font-7">
                Enable SDK to set CV
                <Tooltip text="ironSource SDK will automatically set the CV value in Apple’s Store Kit"/>
            </span>
        </div>
        <div class="grid">
            <span class="font-6" v-once>
                {{ schema.apps.length ? `${schema.apps.length} selected` : 'None' }}
            </span>
            <span class="font-6" v-once>
                <IconBase iconName="statusDotsIcon"
                          :iconColor="getStatusIconColor"
                          height="10"
                          width="10"
                          class="enable-sdk-icon"
                />
                {{ this.schema.enableSDKSetCV ? 'On' : 'Off' }}
            </span>
        </div>
        <span class="actions">
            <IconMenu uniqueId="cvMenu"
                      :menuItems="moreMenuItems"
                      @actionClicked="handleMoreMenuClick"
                      trigger="click"
                      class="menu"
            >
                <button type="button"
                        class="secondary menu-button">
                        <IconBase width="5"
                                  height="16"
                                  iconName="moreIcon"
                                  class="rotated"
                                  verticalAlign="middle"
                                  :iconColor="consts.COLORS.LIGHT_900"/>
                    </button>
            </IconMenu>
            <button class="primary export-button" type="button" @click="exportCSV">
                <IconBase width="13"
                          height="15"
                          iconName="downloadIcon"
                          :iconColor="consts.COLORS.WHITE"/>
            </button>
        </span>
    </div>
</template>

<script>
import Tooltip from 'components/Tooltip/Tooltip.vue';
import IconBase from 'components/IconBase.vue';
import consts from 'services/metaData/consts';
import IconMenu from 'components/iconMenu/IconMenu.vue';
import authService from 'services/auth.js';

export default {
    name: 'CVManagerViewHeader',
    components: { IconMenu, IconBase, Tooltip },
    props: {
        schema: Object
    },
    data: () => ({
        consts,
        moreMenuItems: [
            {
                id: 'edit',
                name: 'Edit',
                iconData: {
                    name: 'editIcon', height: 15, width: 15
                }
            },
            {
                id: 'delete',
                name: 'Delete',
                iconData: {
                    name: 'deleteIcon', height: 15, width: 13
                }
            }
        ]
    }),
    computed: {
        getStatusIconColor() {
            return this.schema.enableSDKSetCV ? consts.COLORS.POSITIVE_500 : consts.COLORS.LIGHT_800;
        }
    },
    methods: {
        handleMoreMenuClick(id) {
            this.$emit(id);
        },
        exportCSV() {
            // headers
            let cvRows = [['cv', 'ad_revenue']];

            // data - in dollars
            cvRows = cvRows.concat(this.schema.steps.map((cvRow) => [cvRow.key, cvRow.max / 100]));

            if (this.schema.steps.length > 1) {
                cvRows.push([this.schema.steps.length, 'Infinity']);
            }

            const blob = new Blob([cvRows.join('\r\n')], { type: 'text/csv;charset=utf-8' });
            const fileName = `${this.schema.name}.csv`;
            if (!window.navigator.msSaveOrOpenBlob) {
                const csvElement = document.createElement('a');
                csvElement.setAttribute('href', window.URL.createObjectURL(blob));
                csvElement.setAttribute('download', fileName);
                csvElement.click();
            } else {
                window.navigator.msSaveBlob(blob, fileName);
            }
        }
    },
    async created() {
        const isTester = await authService.isAuthorized(['monetizerTester']);
        const isReader = await authService.isAuthorized(['viewer']);

        if (isTester || isReader) {
            this.moreMenuItems = this.moreMenuItems.map((item) => ({
                ...item,
                disabled: true
            }));
        }
    }
};
</script>

<style scoped lang="scss">
@import "~styles/styleGuide";
@import "~styles/buttons";

.header-wrap {
    background-color: $white;
    padding: 26px 32px 20px;
    border-top-left-radius: 8px;
    border-top-right-radius: 8px;
    border-bottom: 1px solid $light-200;
    position: relative;
}

.title {
    color: $dark-300;
    margin-bottom: 16px;
    line-height: normal;
}

.rotated {
    transform: rotate(90deg);
}

.actions {
    position: absolute;
    right: 32px;
    top: 44px;

    button {
        min-width: initial;
        width: 32px;
        padding: 0;
        border: none;
        outline: none;
    }

    .menu-button {
        background-color: $light-300;

        &:hover {
            background-color: $light-500;
        }
    }

    .export-button {
        margin-left: 8px;
    }
}

.menu {
    display: inline-block;

    /deep/ .click-trigger{
        top: 36px;
        left: -101px;
    }
}

.enable-sdk-icon {
    margin-right: 3px;
}

.grid {
    display: grid;
    grid-column-gap: 32px;
    grid-template-columns: 100px 136px auto;
    color: $light-800;
    line-height: normal;

    &.grid-titles {
        margin-bottom: 4px;
    }
}
</style>
